import React, { FC, useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import useScreenRecognition from 'gatsby-theme-husky/src/hooks/useScreenRecognition';

import Image from 'common/Image';
import { LanguageSelector, LanguageSelectorPopup } from 'components/LangugageSelector';
import NavItem from 'components/NavItem';
import SocialNetworks from 'components/SocialNetworks';

import { HeaderProps, Language } from './models';

import './Header.scss';

function getCurrentLanguage(list: Language[] | undefined): Language | undefined {
  if (typeof window !== 'undefined' && list) {
    const current = list.find(({ code }) => code === window.location.pathname.split('/')[1]);

    return current;
  }

  return undefined;
}

const Header: FC<HeaderProps> = ({
  data: { logo, navs, socialMediaLogo },
  settings: { avaliableLanguages, popupLanguage },
  alterlogo,
}) => {
  const [load, setLoad] = useState(true);
  const [expanded, setExpanded] = React.useState(false);
  const [activeNavItem, setActiveNavItem] = React.useState<string | null>(null);
  const currentLanguage = getCurrentLanguage(avaliableLanguages);
  const { isMobile } = useScreenRecognition();

  useEffect(() => {}, [activeNavItem]);

  const handleMouseLeave = () => {
    if (isMobile) return;
    setActiveNavItem(null);
  };

  const onHandlerNavbar = () => {
    setExpanded(!expanded);
    setActiveNavItem(null);
  };

  if (isMobile && load && socialMediaLogo) {
    setLoad(false);
    navs.push(...socialMediaLogo);
  }

  return (
    <header className="fixed-top">
      <div className="header mx-auto">
        {navs && navs.length > 0 ? (
          <Navbar expand="md" variant="dark" className="py-0 nav" expanded={expanded}>
            <>
              <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={onHandlerNavbar}>
                <span className="fas fa-bars" />
              </Navbar.Toggle>
              <Navbar.Collapse id="menu">
                <Nav className="header__nav">
                  {navs.slice(0, 5).map((navItem, index) => {
                    const hasSubMenu =
                      navItem.navigationWithSubMenu && navItem.navigationWithSubMenu.length > 0;

                    return (
                      <div
                        key={navItem.id || navItem.slug || `${navItem.label}-${index}`}
                        className={`nav-item ${activeNavItem === navItem.label ? 'active' : ''}`}
                        onMouseEnter={() => {
                          if (!isMobile && hasSubMenu) {
                            setActiveNavItem(navItem.label);
                          }
                        }}
                        onMouseLeave={handleMouseLeave}
                      >
                        {navItem.label ? (
                          <NavItem
                            {...{
                              navItem,
                              hasSubMenu,
                              activeNavItem,
                              setExpanded,
                              setActiveNavItem,
                            }}
                          />
                        ) : (
                          <SocialNetworks
                            socialMediaLogo={socialMediaLogo}
                            className="social__icon-group--mobile"
                            sizeIcon="social__icon--mobile"
                          />
                        )}
                      </div>
                    );
                  })}
                </Nav>
              </Navbar.Collapse>
            </>
            <>
              {!isMobile && (
                <SocialNetworks
                  socialMediaLogo={socialMediaLogo}
                  className="social__icon-group--desktop"
                  sizeIcon="social__icon--desktop"
                />
              )}
            </>
          </Navbar>
        ) : (
          <></>
        )}
        <div className="header__logo">
          <Navbar.Brand href={currentLanguage?.url || '/'}>
            <Image className="logo" imageData={alterlogo || logo} alt={logo?.altText || ''} />
          </Navbar.Brand>
        </div>
        {avaliableLanguages && avaliableLanguages.length > 1 ? (
          <div className={navs && navs.length > 0 ? '' : 'header__language'}>
            <LanguageSelector list={avaliableLanguages} />
            <LanguageSelectorPopup list={avaliableLanguages} title={popupLanguage} />
          </div>
        ) : (
          <></>
        )}
      </div>
    </header>
  );
};

export default Header;
